import { InjectionToken } from '@angular/core';

/**
 * Injection token for window.localStorage access
 * Enables dependency injection and testing of localStorage operations
 */
export const STORAGE_TOKEN = new InjectionToken<Storage>('STORAGE_TOKEN', {
  providedIn: 'root',
  factory: () => window.localStorage,
});
